(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(toastConfig);

    toastConfig.$inject = ['toastrConfig', '$provide', '$injector'];

    function toastConfig(toastrConfig, $provide, $injector) {

        angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 1,
            newestOnTop: true,
            positionClass: 'toast-bottom-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            target: 'body',
            closeButton: true,
            tapToDismiss: false,
            timeOut: 2000,
            extendedTimeOut: 1000
        });

        $provide.decorator('toastr', toastrDecorator);

        toastrDecorator.$inject = ['$delegate', '$parse', '$state'];

        function toastrDecorator($delegate, $parse, $state) {

            $delegate.alarm = function (config) {
                var message = '<span class="toast-alarm-equipment">' + config.equipment + '</span>';
                message += '<span class="toast-alarm-interface">' + config.interface + '</span>';
                message += '<span class="toast-alarm-type">' + config.type + '</span>';
                openToast(message, config.title, config.severity);
            }

            $delegate.rogue = function (message) {
                openToast(message, null, 'rogue');
            }

            function openToast(message, title, type) {
                $delegate.warning(message, title, {
                    iconClass: 'toast-alarm-' + type,
                    closeHtml: '<button><span class="icon icon-close-toast"></span></button>',
                    allowHtml: true,
                    onTap: function () {
                        $state.go('alarms')
                    }
                });
            }

            return $delegate;

        }
    }
})();